// @flow

import config from '../../config/app.config.js';
import { setCookie } from '../../utils/CommonUtils';
import type { CommonState, CommonActions } from '../types';
import {
  SUBSTEP_UPDATE,
  SAVE_JWT,
  STEP_UPDATE,
  GLOBAL_LOADING,
  UPDATE_TITLE,
  OVERRIDE_BACK,
  SAVE_EMAIL,
  SAVE_PHONE,
  SAVE_DEPOSIT,
  SAVE_CB_SCAN,
  SAVE_IDENTITY_SCAN,
  REFRESH_TOKEN_DONE,
  FROM_CODE_ACTIVATION,
  REDIRECT_USER,
  WS_GET_USER_REGISTRATION_SUCCESS,
} from '../actions';

export const initialState: CommonState = {
  step: 0,
  subStep: 0,
  jwt: null,
  globalLoading: false,
  titleMobile: '',
  prevStep: -1,
  email: null,
  international_phone_number: null,
  deposit: null,
  cbScan: null,
  identityScan: null,
  jwtExpirationTime: null,
  fromCodeActivation: false,
  redirectUser: false,
};

export const commonReducer = (
  state: CommonState = initialState,
  action: CommonActions
): CommonState => {
  switch (action.type) {
    case STEP_UPDATE:
      return {
        ...state,
        step: action.payload,
      };
    case SUBSTEP_UPDATE:
      return {
        ...state,
        subStep: action.payload,
      };
    case SAVE_EMAIL:
      return {
        ...state,
        email: action.payload,
      };
    case SAVE_PHONE:
      return {
        ...state,
        international_phone_number: action.payload,
      };
    case SAVE_DEPOSIT:
      return {
        ...state,
        deposit: action.payload,
      };
    case SAVE_JWT:
      setCookie(config.nameCookieJWT, action.payload || '', config.expCookieJWT);
      return {
        ...state,
        jwt: action.payload,
        jwtExpirationTime: Math.round(
          new Date(Date.now() + config.refreshToken.defaultTokenDurationMin * 60000).getTime() /
            1000
        ),
      };
    case GLOBAL_LOADING:
      return {
        ...state,
        globalLoading: action.payload,
      };
    case UPDATE_TITLE:
      return {
        ...state,
        titleMobile: action.payload,
      };
    case OVERRIDE_BACK:
      return {
        ...state,
        prevStep: action.payload,
      };
    case SAVE_CB_SCAN:
      return {
        ...state,
        cbScan: action.payload,
      };
    case SAVE_IDENTITY_SCAN:
      return {
        ...state,
        identityScan: action.payload,
      };
    case REFRESH_TOKEN_DONE:
      if (action.payload) {
        const refreshToken = action.payload;
        setCookie(config.nameCookieJWT, refreshToken.token || '', config.expCookieJWT);
        return {
          ...state,
          jwt: refreshToken.token,
          jwtExpirationTime: refreshToken.expiration_time,
        };
      }
      return state;
    case FROM_CODE_ACTIVATION:
      return {
        ...state,
        fromCodeActivation: action.payload,
      };
    case REDIRECT_USER:
      return {
        ...state,
        redirectUser: action.payload,
      };
    case WS_GET_USER_REGISTRATION_SUCCESS:
      return {
        ...state,
        identityScan: action.payload.identity_scan,
      };
    default:
      return state;
  }
};
